<template>
  <div data-testid="freebie-counter">
    <div class="deal-freebie-description">
      <span
        v-if="deal.freebie_downloads_total > 0"
      >
        Total Downloads: {{ deal.freebie_downloads_total.toLocaleString() }}
      </span>
      <span
        v-else
        class="appsumo-link-container"
      >
        <a
          :href="`${deal.get_absolute_url}`"
          data-testid="deal-no-downloads-url"
          class="appsumo-link"
        >
          Be the first to download!
        </a>

      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FreebieCounter',
  props: {
    deal: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style scoped>
  .appsumo-link-container {
    position: relative;
    z-index: 1;
  }
</style>
